import Accordion from './Modules/Accordion'

const initAccordionOnLoad = function () {
    new Accordion()
}

// If the script is initialized after the document is already loaded, initialize modules instantly
if (document.readyState !== 'loading') {
    initAccordionOnLoad()
} else {
    // else add an event listener for when the document is fully loaded
    document.addEventListener('DOMContentLoaded', initAccordionOnLoad)
}
